export enum TestResultId {
  Pos = 1,
  Neg = 2,
  QuantityNotSufficient = 8,
  Positive = 27,
  Negative = 28
}